import React from 'react'
import { useAtomValue } from 'jotai'
import { userAtom } from '../../store/userAtoms'
import { isAdmin } from '../../utils/roleGuard'
import { AdminLayout } from '../AdminLayout'
import { useTar } from '@/modules/i18n'

interface AdminRouteGuardProps {
  children: React.ReactNode
}

export const AdminRouteGuard: React.FC<AdminRouteGuardProps> = ({ children }) => {
  const user = useAtomValue(userAtom)
  const { t } = useTar()

  if (!user) {
    return (
      <div className="flex items-center justify-center w-full">
        <div className="space-y-8">
          <div className="text-center">
            <h2 className="mt-6 text-3xl font-extrabold text-foreground">
              {t('admin.authenticationRequired')}
            </h2>
            <p className="mt-2 text-sm text-muted-foreground">
              {t('admin.pleaseSignIn')}
            </p>
          </div>
        </div>
      </div>
    )
  }

  if (!isAdmin(user)) {
    return (
      <div className="flex items-center justify-center w-full">
        <div className="space-y-8">
          <div className="text-center">
            <h2 className="mt-6 text-3xl font-extrabold text-error">
              {t('admin.accessDenied')}
            </h2>
            <p className="mt-2 text-sm text-muted-foreground">
              {t('admin.accessDeniedDescription')}
            </p>
            <p className="mt-1 text-xs text-muted">
              {t('admin.adminRoleRequired')}
            </p>
          </div>
        </div>
      </div>
    )
  }

  return <AdminLayout>{children}</AdminLayout>
}
